function ModalTitle({ title }) {
  return <h4>{title}</h4>;
}

function ModalHeader({ children, onClose }) {
  return (
    <div className="modal-header">
      {children}
      <button
        onClick={onClose}
        type="button"
        className="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true"></span>
      </button>
    </div>
  );
}

function ModalBody({ children }) {
  return <div className="modal-body">{children}</div>;
}

function ModalFooter({ children, style }) {
  return (
    <div style={style} className="modal-footer justify-content-between">
      {children}
    </div>
  );
}

Modal.Footer = ModalFooter;
Modal.Body = ModalBody;
Modal.Title = ModalTitle;
Modal.Header = ModalHeader;

export default function Modal({ isShown, children, size = "lg", onClose }) {
  return (
    isShown && (
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
        className="modal"
        style={{ display: "block", paddingRight: 17, background: "#00000044" }}
      >
        <div className={`modal-dialog modal-${size}`}>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    )
  );
}
